import { $api } from "../../../../services/request.config";
import { GET_INDIVIDUAL_COEFFICIENTS_DRAFT } from "../../../../enums/Request/individualCoefficients.types";

import IndividualCoefficientsService from "../../../../../frontend.services/LeaderRequests/IndividualCoefficientsService";

export const updateIndividualCoefficientThunkAction = ({ uid, version, rows }) => async (dispatch) => {
    try {
        const response = await $api.put(`v1/managers/requests/individual-coefficients/${uid}`, {
            version,
            rows: rows.map((row) => ({
                prid: row.prid,
                pid: row.pid,
                motivationAmount: row.motivationAmount === "" || row.motivationAmount === null ||
                row.motivationAmount === undefined
                    ? null
                    : Number(row.motivationAmount),
            })),
        });
        if (!IndividualCoefficientsService.isValidRequestResponse(response.data, uid)) {
            return {
                ok: false,
                error: { kind: "integration", message: "Сервер вернул некорректный ответ. Попробуйте ещё раз." },
            };
        }
        dispatch({ type: GET_INDIVIDUAL_COEFFICIENTS_DRAFT, payload: response.data });
        return { ok: true, data: response.data };
    } catch (error) {
        return { ok: false, error: IndividualCoefficientsService.classifyError(error) };
    }
};